export default "__VITE_ASSET__S9jj3ERp__"